import '@meterup/atto/src/styles/fonts.css';
import './sentry';

import { enableMapSet } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/App';
// Need this to fix console error regeneratorRuntime is not defined.
import { initDatadog } from './datadog';
import { initializePosthog } from './utils/initializePosthog';

initializePosthog();
enableMapSet();
initDatadog();

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
